export default {
    openCalendar: false
};
